export const SIZE_CLASSES = {
  default: 'private-button--default',
  sm: 'private-button--sm',
  xs: 'private-button--xs',
  md: 'private-button--default',
};

export const USE_CLASSES = {
  danger: 'private-button--destructive',
  link: 'private-button__link',
  'link-danger': 'private-button__link private-button__link--danger',
  'link-on-dark': 'private-button__link private-button__link--on-dark',
  'link-on-bright': 'private-button__link private-button__link--on-bright',
  primary: 'private-button--primary',
  'primary-white': 'private-button--primary--white',
  secondary: 'private-button--secondary',
  'secondary-ghost': 'private-button--secondary--ghost',
  tertiary: 'private-button--tertiary',
  'tertiary-light': 'private-button--tertiary-light',
  'tertiary-extra-light': 'private-button--tertiary-extra-light',
  transparent: 'private-button--transparent',
  unstyled: 'private-button--unstyled',
  form: 'private-button--form private-form__control',
  'form-on-dark':
    'private-button--form private-form__control private-button--form--on-dark',
};

export const BUTTON_USES = [
  'danger',
  'link',
  'link-danger',
  'link-on-dark',
  'link-on-bright',
  'primary',
  'primary-white',
  'secondary',
  'secondary-ghost',
  'tertiary',
  'tertiary-light',
  'tertiary-extra-light',
  'transparent',
  'unstyled',
  'form',
  'form-on-dark',
] as const;

export const LINK_USES = ['link', 'link-danger', 'link-on-dark'] as const;
